import { render, staticRenderFns } from "./addServe.vue?vue&type=template&id=4254695f&scoped=true&"
import script from "./addServe.vue?vue&type=script&lang=js&"
export * from "./addServe.vue?vue&type=script&lang=js&"
import style0 from "./addServe.vue?vue&type=style&index=0&id=4254695f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4254695f",
  null
  
)

export default component.exports